import React, { memo, useEffect } from 'react';
import BookingFormStore from 'Stores/BookingFormStore';
import ajaxRequest from 'Functions/ajax/ajaxRequest';
import { action } from 'Shared/Routes';
import { getUrlParameter } from 'Shared/utilities';
const DEFAULT_ERROR = {
  token_error: true,
  error: 'Réservation introuvable ou expirée.'
};
export default memo(function BookingPaymentTokenVerification({
  ...props
}) {
  useEffect(function () {
    const token = getUrlParameter('token');
    if (!token) return;
    BookingFormStore.update(s => {
      s.loading = true;
    });
    (async function () {
      try {
        var {
          booking
        } = await ajaxRequest(action('verifyBackPaymentToken'), {
          data: {
            token: token
          }
        });
        if (!booking) throw DEFAULT_ERROR;
      } catch (update) {
        BookingFormStore.update(function (store) {
          Object.keys(update).forEach(field => store[field] = update[field]);
          store.token_error = true;
        });
        return;
      }
      BookingFormStore.update(function (store) {
        const update = {
          loading: false,
          reservation_source: 'offline',
          step: 2,
          date: booking.date,
          people: booking.number_of_people,
          start: booking.start_hour,
          end: '',
          space: booking.coworking_space,
          amount: booking.amount,
          services: booking.services,
          disposition: booking.disposition,
          booking_id: booking.id
        };
        Object.keys(update).forEach(field => store[field] = update[field]);
        window.localStorage.setItem('current_booking_id', booking.id);
        window.localStorage.setItem('current_booking_price', booking.amount);
        window.localStorage.setItem('amount', props.amount);
      });
    })();
  }, []);
  return null;
});
